import { message } from 'antd';
import Upload from 'antd/es/upload/Upload';
import type { UploadProps } from 'antd';
import { DarwinButton } from 'components/darwin-ui';
import { useTranslation } from 'react-i18next';
import { useUploadLocationImg } from 'api/services/organizationService';
import { ErrorType } from 'types/genericTypes';
import { useFloatNotification } from 'contexts/FloatNotificationContext';

interface UploadLocationImageProps {
  setImage: (url: string) => void;
}

export const UploadLocationImage: React.FC<UploadLocationImageProps> = ({
  setImage,
}) => {
  const { t } = useTranslation();
  const { openNotification } = useFloatNotification();
  const { mutateAsync: uploadImg } = useUploadLocationImg();

  const beforeUpload = (file: File) => {
    const isImage = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isImage) {
      message.error(t('create-organization-form.format-error'));
    }
    const isSmallEnough = file.size / 1024 / 1024 < 10;
    if (!isSmallEnough) {
      message.error(t('create-organization-form.file-size'));
    }
    return isImage && isSmallEnough;
  };

  const customRequest: UploadProps['customRequest'] = async options => {
    const { file, onSuccess, onError } = options;
    try {
      const res = await uploadImg({ file: file as File });
      setImage(res.data.id);
      onSuccess?.(res);
    } catch (err) {
      const apiError = err as ErrorType;
      if (apiError.body?.errorCode) {
        openNotification(t('error'), t(apiError.body.errorCode), 'error');
      } else {
        openNotification(
          t('error'),
          t('create-organization-form.error-uploading-img'),
          'error'
        );
      }
      onError?.(err as any);
    }
  };

  return (
    <Upload
      name="file"
      maxCount={1}
      beforeUpload={beforeUpload}
      customRequest={customRequest}
    >
      <DarwinButton type="primary">
        {t('create-organization-form.upload-data')}
      </DarwinButton>
    </Upload>
  );
};
